import 'slick-carousel';

const $slider = $('.reviews .slick-slider');
const videos = Array.from(document.querySelectorAll('.description video'));

$('.js-scroll-below').on('click', function scroll(e) {
  e.preventDefault();
  const $this = $(this);
  const $main = $('html, body');
  const $elScrollTo = $('.' + $this.data('scroll-to'));
  const top = $elScrollTo.offset().top - 36;

  $main.animate({
    scrollTop: top
  }, 1000);

});

$slider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  fade: false,
  speed: 500,
  mobileFirst: true,
  prevArrow: $('.arrow.prev'),
  nextArrow: $('.arrow.next'),
  autoplay: true,
  autoplaySpeed: 8000,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        dots: false,
        autoplay: false
      }
    }
  ]
});

const isInViewport = (elem) => {
  const bounding = elem.getBoundingClientRect();

  return (
    bounding.top >= -650 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight + 650 || document.documentElement.clientHeight + 650) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const playVideo = _globalUtils.debounce(() => {
  videos.forEach(video => {
    if (isInViewport(video) && (video.dataset.played === 'false')) {
      video.setAttribute('data-played', 'true');
      const sourceEl = document.createElement('source');

      sourceEl.src = video.dataset.src;
      video.append(sourceEl);
    }
  });
}, 300);

window.addEventListener('scroll', playVideo);
